import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { InputV2, ButtonLoading, Icons } from 'components';
import { useStyles } from './Style';
import { useNavigate } from 'react-router-dom';
import createToast from 'components/Toast/Toast';
import UploadFiles from 'components/UploadFile';
import GuidDg from '../GuidDg';
import Services from '../../services/Services';
const CheckRegistration = (props) => {
  const { lastData = null, isEnable = true } = props;
  const [files, setFile] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [chequeId, setChequeId] = useState('');
  const [isVerify, setIsVerify] = useState(0);
  const [fileHash, setFileHash] = useState([]);
  const [isLoadProgress, setIsLoadProgress] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (lastData) {
      let env = process.env?.REACT_APP_ENVIRONMENT;
      setFileHash([]);
      setFile([]);
      lastData?.source['cheque-inquiry']?.['images'].map((img) => {
        setFileHash((oldArray) => [
          ...oldArray,
          {
            hash: img,
            name: 'تصویر چک',
            url: `${process.env?.REACT_APP_BASE_URL_UPLOAD_PODSAPCE + img}`,
          },
        ]);
        setFile((oldArray) => [...oldArray, { ...img }]);
      });
      setChequeId(lastData?.source['cheque-inquiry']?.['sayad-id']);
      methods.setValue('sayadId', lastData?.source['cheque-inquiry']?.['sayad-id']);
      if (lastData?.source['cheque-inquiry']?.['sayad-id']) {
        setIsVerify(1);
      }
    }
  }, []);
  const onSubmit = () => {
    setSubmitLoading(true);
    let hashData = fileHash.map((d) => {
      return d.hash;
    });
    const data = {
      chequeImages: hashData.slice(-2),
      sayadId: chequeId,
    };
    Services.postChequeRegistrationFinal(lastData?.source['entity-id'], data)
      .then((res) => {
        setSubmitLoading(false);
        createToast('موفق', 'عملیات با موفقیت انجام شد', 'success');

        navigate('/Warranty/Requestlist');
      })
      .catch((error) => {
        setSubmitLoading(false);
      });
  };

  const chequeInquiry = () => {
    setIsLoadProgress(true);
    const data = {
      SayadId: chequeId,
    };
    Services.postChequeInquiry(data)

      .then((res) => {
        setIsLoadProgress(false);
        setIsVerify(1);
        createToast('موفق', 'استعلام با موفقیت انجام شد', 'success');
      })
      .catch((error) => {
        setIsLoadProgress(false);
        setIsVerify(2);
      });
  };

  const methods = useForm();
  const classes = useStyles();
  const [isOpenAgentDg, setIsOpenAgentDg] = useState(false);
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} autoComplete="off">
        <Grid container spacing={3}>
          <Grid direction="row" spacing={3} container item xs={12} md={12} lg={5}>
            <Grid
              item
              md={12}
              xs={12}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '35px 15px 10px',
              }}
            >
              <h4 style={{ fontWeight: 'bold' }}>راهنمای نوشتن چک</h4>
              <ButtonLoading
                type="button"
                color="primary"
                variant="outlined"
                onClick={() => {
                  setIsOpenAgentDg(true);
                }}
                name={
                  <>
                    <span style={{ marginLeft: '5px' }}>
                      <Icons icon="Info" color="#667585" size={23} />
                    </span>
                    مشاهده راهنما
                  </>
                }
              />
            </Grid>
            <Grid
              item
              className={classes.blockFieldProgress}
              spacing={1}
              style={{
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <Grid item xs={8} lg={10} style={{ position: 'relative' }}>
                <InputV2
                  fullWidth
                  errors={methods.formState.errors}
                  rules={['isNumeric', 'isLt|16', 'required']}
                  label=" شناسه چک صیادی"
                  name="sayadId"
                  tooltip=" چک به عنوان وثیقه ضمانت‌نامه در این مرحله ثبت می‌شود و شناسه می بایست 16 رقم باشد. "
                  register={methods.register}
                  forceValue={chequeId}
                  onChangeValue={(e) => {
                    setIsVerify(0);
                    setChequeId(e?.target?.value);
                  }}
                />
                {isVerify === 1 ? (
                  <Icons icon="Accept" color="#43A047" size={23} />
                ) : isVerify === 2 ? (
                  <Icons icon="CloseCircle" color="#F44336" size={23} />
                ) : (
                  ''
                )}
              </Grid>
              <Grid item xs={4} lg={2}>
                <ButtonLoading
                  type="button"
                  variant="contained"
                  color="primary"
                  loading={isLoadProgress}
                  disabled={isLoadProgress}
                  style={{ margin: '17px 0 0', width: '100%' }}
                  onClick={() => {
                    chequeInquiry();
                  }}
                  name={<>استعلام</>}
                />
              </Grid>
            </Grid>
            <Grid md={12} xs={12} item>
              <UploadFiles
                label="آپلود چک صیادی"
                tooltip="فرمت فایل ارسالی به صورت jpg ,jpeg ,png می‌باشد."
                hasLink={true}
                beforeUlpoadList={lastData ? fileHash : null}
                setList={setFileHash}
                limitUpload={2}
                multiple={true}
                acceptsFile=".jpeg ,.jpg ,.png"
                acceptsList="jpeg ,jpg ,png"
                type="WARRANTY"
                warrantyType="CHEQUE"
              />
            </Grid>

          </Grid>
          <Grid md={12} xs={12} lg={12} style={{ display: 'flex' }} justifyContent="flex-end">
            <ButtonLoading
              type="submit"
              style={{ margin: '30px 8px 0' }}
              variant="contained"
              loading={submitLoading}
              color="primary"
              disabled={isVerify !== 1 || fileHash?.length < 2 || submitLoading}
              name="ثبت چک "
            />
          </Grid>
        </Grid>
      </form>
      <GuidDg isOpenAgentDg={isOpenAgentDg} setIsOpenAgentDg={setIsOpenAgentDg} data={null} />
    </FormProvider>
  );
};
export default CheckRegistration;
